
<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-4">Keagenan - Location</h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
          </CRow>
          <CButtonGroup>
              <CButton color="secondary" @click="handleChooseStatus(1)">Provinsi</CButton>
              <CButton color="secondary" @click="handleChooseStatus(2)">Kota</CButton>
              <CButton color="secondary" @click="handleChooseStatus(3)">Kecamatan</CButton>
              <CButton color="secondary" @click="handleChooseStatus(4)">Kelurahan</CButton>
            </CButtonGroup>
        </CCardHeader>
        
        <CCardBody>
          <table-province v-if="status === 'Province'"></table-province>
          <table-district v-if="status === 'District'"></table-district>
          <table-sub-district v-if="status === 'Subdistrict'"></table-sub-district>
          <table-village v-if="status === 'Village'"></table-village>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import Vue from "vue"
import axios from "axios";
import jwt from "jsonwebtoken";
import TableProvince from "./tables/Province"
import TableDistrict from "./tables/District"
import TableSubDistrict from "./tables/SubDistrict"
import TableVillage from "./tables/Village"

Vue.component('table-province',TableProvince)
Vue.component('table-district',TableDistrict)
Vue.component('table-sub-district',TableSubDistrict)
Vue.component('table-village',TableVillage)

export default {
  name: "Aplicant",
  data() {
    return {
      status:"Province",
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {

  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      }
    }
  },
  beforeMount() {
    const data = jwt.decode(localStorage.getItem("token"));
    if (data === null) {
      this.$router.push({ path: `/pages/login` });
    } else {
      axios
        .get(`${this.domain}/v1/account/${data.account_id}`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          // JSON responses are automatically parsed.
          this.accountData = response.data;
        })
        .catch(e => {
          this.$router.push({ path: `/pages/login` });
          console.log(e);
        });
    }
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "NPOS" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null
      } else {
        this.$router.push({ path: `/` });
      }
    },
    handleChooseStatus(event){
        if (event === 1){
        this.status = "Province"
        }else if (event === 2){
        this.status = "District"
        }else if (event === 3){
        this.status = "Subdistrict"
        }else if (event === 4){
        this.status = "Village"
        }
    },
  }
};
</script>
